import { Instagram, MessageCircle, Lock } from "lucide-react";
import { SeedMark } from "./SeedMark";

export const Footer = () => (
  <footer className="bg-seed-deep py-20 text-seed-off" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col items-start justify-between gap-12 md:flex-row md:items-end">
        <div>
          <div className="flex items-center gap-4">
            <SeedMark size={44} />
            <span className="font-heading text-4xl font-black tracking-tighter sm:text-5xl" data-testid="footer-brand">
              Seed{" "}<span className="text-seed-vivid">Imóveis</span>
            </span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-seed-off/60">
            Facilitando conquistas — imóveis urbanos e rurais com atendimento humano e soluções sob medida.
          </p>
        </div>
        <div className="text-sm">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-seed-vivid">Fale com a gente</p>
          <a
            href="https://wa.me/5534999236969"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-heading text-2xl font-bold transition-colors duration-300 hover:text-seed-vivid"
            data-testid="footer-phone"
          >
            <MessageCircle size={20} /> 34 99923-6969
          </a>
          <a
            href="https://instagram.com/seed.imoveis"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 text-base font-semibold text-seed-off/70 transition-colors duration-300 hover:text-seed-vivid"
            data-testid="footer-instagram"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-seed-off/25">
              <Instagram size={16} />
            </span>
            @seed.imoveis
          </a>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-seed-off/15 pt-8 text-xs text-seed-off/40 md:flex-row md:items-center md:justify-between">
        <span>© {new Date().getFullYear()} Seed Imóveis. Todos os direitos reservados.</span>
        <div className="flex items-center gap-6">
          <span>Facilitando conquistas.</span>
          <a
            href="/admin/login"
            className="flex items-center gap-1.5 text-seed-off/30 transition-all duration-300 hover:text-seed-vivid"
            data-testid="footer-admin-link"
            aria-label="Acesso restrito à equipe"
          >
            <Lock size={11} /> Acesso restrito
          </a>
        </div>
      </div>
    </div>
  </footer>
);
